module.exports = __webpack_public_path__ + "static/media/vehicle4.7347c0e1.svg";